// extracted by mini-css-extract-plugin
module.exports = {"root":"ChipsList_root__8_Ge8","chipContainer":"ChipsList_chipContainer__2Db5C"};